import { apiFetch } from '@/lib/api';

export interface Investor {
  id: string;
  name: string;
  display_order: number;
  active: boolean;
  notes: string | null;
  updated_at: string;
}

export async function listInvestors(includeInactive = false): Promise<Investor[]> {
  return apiFetch<Investor[]>(`/investors${includeInactive ? '?include_inactive=true' : ''}`);
}
